import React from 'react';
import { usePlatform } from '../../context/PlatformContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';
export const PlatformToggle: React.FC = () => {
  const {
    isAfterTide,
    togglePlatform
  } = usePlatform();
  const dk = useDarkClasses();
  return <div className="flex items-center" data-id="element-3821" data-mp="6muijn3usndp">
      <div className={`flex items-center rounded-full p-1 border transition-colors cursor-pointer select-none ${dk.isDark ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-gray-50'}`} onClick={togglePlatform} role="button" tabIndex={0} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePlatform();
      }
    }} aria-label={`Switch to ${isAfterTide ? 'LitLaunch' : 'AfterTide'}`} data-id="element-3822" data-mp="1mpwzio392gm">
        {/* LitLaunch Side */}
        <div className={`px-3 py-1.5 rounded-full text-sm font-bold transition-all duration-300 ${!isAfterTide ? `shadow-sm ${dk.isDark ? 'bg-gray-700 text-purple-400' : 'bg-white text-purple-600'}` : `text-gray-500 hover:text-gray-700 dark:hover:text-gray-300`}`} data-id="element-3823" data-mp="3a3kroauqfgjm">
          LitLaunch
        </div>

        {/* AfterTide Side */}
        <div className={`px-3 py-1.5 rounded-full text-sm font-playfair font-bold tracking-wide transition-all duration-300 ${isAfterTide ? `shadow-sm ${dk.isDark ? 'bg-[#1a1a2e] text-[#e2b04a]' : 'bg-[#1a1a2e] text-[#e2b04a]'}` : `text-gray-500 hover:text-gray-700 dark:hover:text-gray-300`}`} data-id="element-3824" data-mp="3g1mw5n5u8e1c">
          AfterTide
        </div>
      </div>
    </div>;
};
export default PlatformToggle;